import { render, staticRenderFns } from "./SurveySubmissionsDetail.vue?vue&type=template&id=3fa2512c&scoped=true"
import script from "./SurveySubmissionsDetail.vue?vue&type=script&lang=js"
export * from "./SurveySubmissionsDetail.vue?vue&type=script&lang=js"
import style0 from "./SurveySubmissionsDetail.vue?vue&type=style&index=0&id=3fa2512c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2512c",
  null
  
)

export default component.exports